import React from 'react';
import { MultiWebClientMerchantModel, MultiWebClientSubItemModel } from '@/User/domain';
import { DROPDOWN_STYLES } from '../constants/styles';
import chevronImg from '@/Shared/ui/assets/chevron.png';

interface DropdownTriggerProps {
  selected: MultiWebClientMerchantModel | MultiWebClientSubItemModel | null;
  open: boolean;
  onClick: () => void;
}

/**
 * Componente atómico para el botón trigger del dropdown.
 * Muestra el comercio seleccionado y permite abrir/cerrar el dropdown.
 * 
 * @param selected - Comercio o sub-item seleccionado actualmente
 * @param open - Estado de apertura del dropdown
 * @param onClick - Función para manejar el clic en el trigger
 */
export const DropdownTrigger: React.FC<DropdownTriggerProps> = ({ selected, open, onClick }) => {
  return (
    <div style={DROPDOWN_STYLES.triggerContainer}>
      <div 
        style={DROPDOWN_STYLES.triggerContent}
        onClick={onClick}
        tabIndex={0}
        role="button"
        aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
      >
        <span style={DROPDOWN_STYLES.triggerTitle}>
          {selected ? selected.name : 'Selecciona un comercio'}
        </span>
        <span style={DROPDOWN_STYLES.triggerSubtitle}>
          {selected ? `${selected.cif} - ${selected.code}` : ''}
        </span>
      </div>
      <button
        type="button"
        aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        style={{
          ...DROPDOWN_STYLES.triggerButton,
          transform: open ? 'none' : 'rotate(180deg)',
        }}
      >
       <img
          src={chevronImg}
          alt="Chevron"
          width={22}
          height={22}
          style={DROPDOWN_STYLES.triggerIcon}
        />
      </button>
    </div>
  );
};
